export default __webpack_public_path__ + "static/media/A0000.d7f1485a.png";